import { EmoticonDevilIcon } from './EmoticonDevilIcon';

/**
 * author: Austin Andrews
 * id 7781F4B7-849F-42A4-82B1-791DBDE91295
 * name emoticon-devil
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-devil.svg
 * tags
 * - Emoji 
 */
export const SmileyDevilIcon = EmoticonDevilIcon;
export default SmileyDevilIcon